"use client"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";


export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Automatically refetch when queries are invalidated
            refetchOnWindowFocus: false, // Optional: disable refetch on window focus
            retry: 1, // Optional: reduce retries
            staleTime: 0, // Consider data stale immediately
        },
    },
})

export const QueryProvider = (props: { children: React.ReactNode }) => {
    return <QueryClientProvider client={queryClient}>{props.children}</QueryClientProvider>
}
